import React from 'react';
import {
  Toolbar,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
} from '@mui/material';
import { DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';

type BulkActionType = '' | 'delete' | 'export';

interface BulkActionsToolbarProps {
  selectedCount: number;
  bulkAction: BulkActionType;
  onBulkActionChange: (action: BulkActionType) => void;
  onApplyBulkAction: () => void;
  onClearSelection: () => void;
}

export const BulkActionsToolbar: React.FC<BulkActionsToolbarProps> = React.memo(({
  selectedCount,
  bulkAction,
  onBulkActionChange,
  onApplyBulkAction,
  onClearSelection,
}) => {
  if (selectedCount === 0) return null;

  return (
    <Toolbar 
      sx={{ 
        mb: 2, 
        bgcolor: 'action.selected', 
        borderRadius: 1,
        justifyContent: 'space-between'
      }}
    >
      <Typography variant="subtitle1">
        {selectedCount} location{selectedCount !== 1 ? 's' : ''} selected
      </Typography>      
      <Box display="flex" alignItems="center" gap={2}>
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel>Action</InputLabel>
          <Select
            value={bulkAction}
            label="Action"
            onChange={(e) => onBulkActionChange(e.target.value as any)}
            size="small"
          >
            <MenuItem value="delete">Delete</MenuItem>
          </Select>
        </FormControl>
        
        <Button 
          variant="outlined"
          onClick={onClearSelection}
          size="small"
        >
          Clear
        </Button>
        
        <Button 
          variant="contained" 
          onClick={onApplyBulkAction}
          disabled={!bulkAction}
          startIcon={<DeleteOutlineIcon />}
          color="error"
        >
          Apply
        </Button>
      </Box>
    </Toolbar>
  );
});

BulkActionsToolbar.displayName = 'BulkActionsToolbar';
